import { SourceBasedExpression } from '../Expression.js';
export class ToLowerCaseExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        return String(source).toLowerCase();
    }
}
//# sourceMappingURL=ToLowerCaseExpression.js.map